import { defineMessages } from 'react-intl';

export default defineMessages({
    addHouseholdMember: {
        id: 'quoteandbind.pup.views.householdMemberDetails.dropdownMenu.AddMember',
        defaultMessage: 'Add Household Member'
    }
});
